module.exports = __webpack_public_path__ + "img/57.b770beb8.jpg";